import { ActionType } from 'typesafe-actions';
import { Enterprise } from '../auth';
import { Project } from '../projects';
import * as actions from './actions';

export type BillingPeriodsAction = ActionType<typeof actions>;

export interface BillingPeriodsState {
  billingPeriods: {
    data: BillingPeriod[] | null;
    loading: boolean;
    error: Error | null;
  };
}

export enum BillingPeriodStatus {
  CLOSE = '0',
  OPEN = '1',
}

export const billingPeriodStatusKorean = {
  '0': '마감',
  '1': '진행중',
} as const;

export interface BillingPeriod {
  id: number;
  label: string;
  projectId?: string;
  project: Partial<Project>;
  enterprise: Partial<Enterprise>;
  status: BillingPeriodStatus;
  startDate: string;
  endDate: string;
  dueDate: string;
}

export interface BillingPeriodParams {
  enterpriseId: string;
  projectId: string;
  billingPeriod?: BillingPeriod;
}
